import {DEFAULT_SEARCH_KEY} from "@/lib/hooks/useDebouncedSearch.ts";
import {DEFAULT_FILTERS_KEY, resolveFilterSets} from "@/lib/hooks/useFilterSets.ts";

interface ListTitleTypeFilter {
  key: string;
  display: Partial<Record<string, string>>;
  /** Noun after the type label when the label already holds part of the list noun, e.g. "Public Status" + "Pages". */
  noun?: string;
}

/**
 * "All <noun>" when nothing narrows the list, "<type> <noun>" when exactly one type is selected, "<noun>" otherwise.
 * Reads the URL, where useTable keeps search and filters, so a page can title a list it does not own.
 */
export const getListTitle = (params: URLSearchParams, noun: string, typeFilter: ListTitleTypeFilter): string => {
  const filterSets = resolveFilterSets(params.get(DEFAULT_FILTERS_KEY) || "");
  const typeValues = filterSets[typeFilter.key];
  const typeDisplay =
    Array.isArray(typeValues) && typeValues.length === 1 ? typeFilter.display[typeValues[0]] : undefined;
  if (typeDisplay) {
    return `${typeDisplay} ${typeFilter.noun ?? noun}`;
  }
  const hasFilter = Object.values(filterSets).some((value) =>
    Array.isArray(value) ? value.length > 0 : !!(value?.from || value?.to)
  );
  const isFiltered = !!params.get(DEFAULT_SEARCH_KEY)?.trim() || hasFilter;
  return isFiltered ? noun : `All ${noun}`;
};
